<form [formGroup]="settingsForm" (ngSubmit)="submit()" [class.fake-hidden]="!showSettings">
  <div class="row p-4">
    <div class="col-6">
      <div class="row mb-3">
        <label [for]="'language-' + entity.id" class="col-5 col-form-label">{{ 'COMMON.LANGUAGES.TITLE' | translate }}</label>
        <div class="col-7 mb-2">
          <select class="form-select" [id]="'language-' + entity.id" formControlName="language">
            <option *ngFor="let language of utils.languages_invision" [value]="language.value">{{('COMMON.LANGUAGES.' +
              language.name) |translate}}</option>
          </select>
        </div>
        <label [for]="'fittingHeight-' + entity.id" class="col-5 col-form-label">{{ 'FIT.FITTING_HEIGHT' | translate }}</label>
        <div class="col-7">
          <select class="form-select" [id]="'fittingHeight-' + entity.id" formControlName="fittingHeight">
            <option value="RIM">{{ 'FIT.RIM' | translate }}</option>
            <option value="BOX">{{ 'FIT.BOX' | translate }}</option>
          </select>
        </div>
        <ng-container *ngIf="entity.entityTypeId === 4 && user.roleId === 1">
          <label [for]="'limitedBandwidth-' + entity.id" class="col-5 col-form-label">Limited Bandwidth</label>
          <div class="col-7">
            <input class="form-check-input float-end" type="checkbox" [id]="'limitedBandwidth-' + entity.id"
              formControlName="limitedBandwidth">
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="row p-4"
    *ngIf="entity.entityTypeId !== 4 || (entity.entityTypeId === 4 && currentSettings?.appFrontendDesign?.logo1?.allowConfiguration)">
    <div class="col-6">

      <h4 class="pb-2 mb-3 border-bottom fw-bold">App Frontend Design</h4>
      <div class="row mb-3">
        <label [for]="'fitmade4uLogo1-' + entity.id" class="col-5 col-form-label">Logo 1
          <hbo-field-info-icon fieldName="fitmade4uLogo1"></hbo-field-info-icon>
          <a *ngIf="currentSettings?.appFrontendDesign?.logo1?.logoImage && !settingsForm.disabled"
            (click)="clearImage($event, 'fitmade4uLogo1')" class="clear-pb"><i class="bi bi-trash"></i></a>
          <a *ngIf="currentSettings?.appFrontendDesign?.logo1?.logoImage"
            (click)="showImage($event, currentSettings?.appFrontendDesign?.logo1?.logoImage!)" class="image-link"
            [ngClass]="{'only-image-link':settingsForm.disabled}"><i
              class="bi bi-image"></i></a>
        </label>
        <div class="col-7">
          <div class="input-group custom-file-button flex-row-reverse">
            <!-- <label class="input-group-text cursor-pointer rounded-0" [for]="'fitmade4uLogo1-' + entity.id">Browse</label> -->
            <label class="label-input-file" [for]="'fitmade4uLogo1-' + entity.id">
              <div>
                <div class="label-input-file-placeholder">
                  {{currentSettings?.appFrontendDesign?.logo1?.logoImage &&
                  currentSettings?.appFrontendDesign?.logo1?.logoName
                  ? currentSettings?.appFrontendDesign?.logo1?.logoName
                  : ('COMMON.UPLOADIMAGE' | translate)
                  }}
                </div>
                <div class="label-input-file-browse">Browse</div>
              </div>
            </label>
            <input type="file" class="form-control"
              [class]="settingsForm.controls.fitmade4uLogo1.value? 'input-file-filled': 'input-file-empty'"
              [id]="'fitmade4uLogo1-' + entity.id" formControlName="fitmade4uLogo1" (change)="uploadFile($event,'fitmade4uLogo1')">
          </div>
          <hbo-field-validation fieldName="fitmade4uLogo1"></hbo-field-validation>
        </div>
      </div>

      <ng-container *ngIf="entity.entityTypeId !== 4">
        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" [id]="'logo1Allow-' + entity.id" formControlName="logo1Allow">
          <label class="form-check-label" [for]="'logo1Allow-' + entity.id">
            {{ 'SETTING.ALLOW' | translate }} (1)
          </label>
        </div>

        <div class="row mb-3">
          <label [for]="'fitmade4uLogo2-' + entity.id" class="col-5 col-form-label">Logo 2
            <hbo-field-info-icon fieldName="fitmade4uLogo2"></hbo-field-info-icon>
            <a *ngIf="currentSettings?.appFrontendDesign?.logo2?.logoImage && !settingsForm.disabled"
              (click)="clearImage($event, 'fitmade4uLogo2')" class="clear-pb"><i class="bi bi-trash"></i></a>
            <a *ngIf="currentSettings?.appFrontendDesign?.logo2?.logoImage"
              (click)="showImage($event, currentSettings?.appFrontendDesign?.logo2?.logoImage!)" class="image-link"
              [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                class="bi bi-image"></i></a>
          </label>
          <div class="col-7">
            <div class="input-group custom-file-button flex-row-reverse">
              <label class="label-input-file" [for]="'fitmade4uLogo2-' + entity.id">
                <div>
                  <div class="label-input-file-placeholder">
                    {{currentSettings?.appFrontendDesign?.logo2?.logoImage &&
                    currentSettings?.appFrontendDesign?.logo2?.logoName
                    ? currentSettings?.appFrontendDesign?.logo2?.logoName
                    : ('COMMON.UPLOADIMAGE' | translate)
                    }}
                  </div>
                  <div class="label-input-file-browse">Browse</div>
                </div>
              </label>
              <input type="file" class="form-control"
                [class]="settingsForm.controls.fitmade4uLogo2.value? 'input-file-filled': 'input-file-empty'"
                [id]="'fitmade4uLogo2-' + entity.id" formControlName="fitmade4uLogo2" (change)="uploadFile($event,'fitmade4uLogo2')">
            </div>
            <hbo-field-validation fieldName="fitmade4uLogo2"></hbo-field-validation>
          </div>
        </div>

        <ng-container *ngIf="entityApps.includes(5)">
          <div class="row mb-3">
            <label [for]="'fitAppName-' + entity.id" class="col-5 col-form-label">FIT App Name</label>
            <div class="col-7">
              <input type="text" class="form-control border-0 rounded-0" [id]="'fitAppName-' + entity.id"
                formControlName="fitAppName">
            </div>
          </div>

          <div class="row mb-3">
            <label [for]="'logoA-' + entity.id" class="col-5 col-form-label">App Logo (A)
              <hbo-field-info-icon fieldName="logoA"></hbo-field-info-icon>
              <a *ngIf="currentSettings?.appFrontendDesign?.fit?.logoImage && !settingsForm.disabled"
                (click)="clearImage($event, 'logoA')" class="clear-pb"><i class="bi bi-trash"></i></a>
              <a *ngIf="currentSettings?.appFrontendDesign?.fit?.logoImage"
                (click)="showImage($event, currentSettings?.appFrontendDesign?.fit?.logoImage!)" class="image-link"
                [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                  class="bi bi-image"></i></a>
            </label>
            <div class="col-7">
              <div class="input-group custom-file-button flex-row-reverse">
                <label class="label-input-file" [for]="'logoA-' + entity.id">
                  <div>
                    <div class="label-input-file-placeholder">
                      {{
                      currentSettings?.appFrontendDesign?.fit?.logoImage
                      ? currentSettings?.appFrontendDesign?.fit?.logoName ?? 'fitLogo'
                      : ('COMMON.UPLOADIMAGE' | translate)
                      }}
                    </div>
                    <div class="label-input-file-browse">Browse</div>
                  </div>
                </label>
                <input type="file" class="form-control"
                  [class]="settingsForm.controls.logoA.value? 'input-file-filled': 'input-file-empty'"
                  [id]="'logoA-' + entity.id" formControlName="logoA" (change)="uploadFile($event,'logoA')">
              </div>
              <hbo-field-validation fieldName="logoA"></hbo-field-validation>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="entityApps.includes(6) && currentSettings?.appFrontendDesign?.m4u">
          <div class="row mb-3">
            <label [for]="'made4uAppName-' + entity.id" class="col-5 col-form-label">Made4U App Name</label>
            <div class="col-7">
              <input type="text" class="form-control border-0 rounded-0" [id]="'made4uAppName-' + entity.id"
                formControlName="made4uAppName">
            </div>
          </div>

          <div class="row mb-3">
            <label [for]="'logoB-' + entity.id" class="col-5 col-form-label">App Logo <span
                *ngIf="!entityApps.includes(5)">(A)</span> <span *ngIf="entityApps.includes(5)">(B)</span>
              <hbo-field-info-icon fieldName="logoB"></hbo-field-info-icon>
              <a *ngIf="currentSettings?.appFrontendDesign?.m4u?.logoImage && !settingsForm.disabled"
                (click)="clearImage($event, 'logoB')" class="clear-pb"><i class="bi bi-trash"></i></a>
              <a *ngIf="currentSettings?.appFrontendDesign?.m4u?.logoImage"
                (click)="showImage($event, currentSettings?.appFrontendDesign?.m4u?.logoImage!)" class="image-link"
                [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                  class="bi bi-image"></i></a>
            </label>
            <div class="col-7">
              <div class="input-group custom-file-button flex-row-reverse">
                <label class="label-input-file" [for]="'logoB-' + entity.id">
                  <div>
                    <div class="label-input-file-placeholder">
                      {{
                      currentSettings?.appFrontendDesign?.m4u?.logoImage
                      ? currentSettings?.appFrontendDesign?.m4u?.logoName ?? 'made4uLogo'
                      : ('COMMON.UPLOADIMAGE' | translate)
                      }}
                    </div>
                    <div class="label-input-file-browse">Browse</div>
                  </div>
                </label>
                <input type="file" class="form-control"
                  [class]="settingsForm.controls.logoB.value? 'input-file-filled': 'input-file-empty'"
                  [id]="'logoB-' + entity.id" formControlName="logoB" (change)="uploadFile($event,'logoB')">
              </div>
              <hbo-field-validation fieldName="logoB"></hbo-field-validation>
            </div>
          </div>
        </ng-container>
      </ng-container>

    </div>

    <div class="col-5 offset-1">
      <div class="mt-4 preview">
        <object *ngIf="entityApps.includes(5) && !entityApps.includes(6)" data="assets/images/preview/fit.png"
          [id]="'layoutThumbnail-' + entity.id"></object>
        <object *ngIf="!entityApps.includes(5) && entityApps.includes(6)" data="assets/images/preview/fit.png"
          [id]="'layoutThumbnail-' + entity.id"></object>
        <object *ngIf="entityApps.includes(5) && entityApps.includes(6)" data="assets/images/preview/fitmade4u.png"
          [id]="'layoutThumbnail-' + entity.id"></object>
        <button type="button" class="btn btn-outline-dark mt-2" (click)="preview()"><i class="bi bi-eye"></i>
          Preview</button>
      </div>
    </div>
  </div>

  <div class="row p-4">
    <div class="col-6">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">Data Protection</h4>
      <div class="row mb-3">
        <ng-container *ngIf="entity.entityTypeId !== 4">
          <label [for]="'dataProcessor-' + entity.id" class="col-5 col-form-label">Data Processor (LOPD)</label>
          <div class="col-7">
            <input type="text" class="form-control border-0 rounded-0" [id]="'dataProcessor-' + entity.id"
              formControlName="LOPDdataProcessor">
          </div>
        </ng-container>
        <ng-container *ngIf="entity.entityTypeId === 4">
          <label [for]="'LOPDname-' + entity.id" class="col-5 col-form-label">Optical Shop Name (LOPD)</label>
          <div class="col-7 mb-2">
            <input type="text" class="form-control border-0 rounded-0" [id]="'LOPDname-' + entity.id"
              formControlName="LOPDName">
          </div>
          <label [for]="'LOPDemail-' + entity.id" class="col-5 col-form-label">Optical shop e-mail (LOPD)</label>
          <div class="col-7">
            <input type="text" class="form-control border-0 rounded-0" [id]="'LOPDemail-' + entity.id"
              formControlName="LOPDEmail">
          </div>
        </ng-container>
      </div>
      <div class="form-check mb-3" *ngIf="entity.entityTypeId !== 4 && user.roleId === 1">
        <input class="form-check-input" type="checkbox" [id]="'allowDelete-' + entity.id" formControlName="allowDelete" [attr.disabled]="user.profileId !== 3 ? true : null">
        <label class="form-check-label" [for]="'allowDelete-' + entity.id">
          {{ 'SETTING.ALLOWDELETE' | translate }}
        </label>
      </div>
    </div>
    <div class="col-6" *ngIf="entity.entityTypeId !== 4">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">Screensaver</h4>
      <div class="mb-3">
        <label class="form-check-label fw-bold" [for]="'screenSaver-' + entity.id">Enable screen saver</label>
        <input class="form-check-input float-end" type="checkbox" [id]="'screenSaver-' + entity.id"
          formControlName="screenSaverEnabled">
      </div>
      <div class="row mb-3">
        <label [for]="'screenSaverVideo-' + entity.id" class="col-5 col-form-label">Screensaver video
          <hbo-field-info-icon fieldName="fitmade4uScreensaverVideo"></hbo-field-info-icon>
          <a *ngIf="settingsForm.controls.screenSaverVideo.value && !settingsForm.disabled" (click)="clearImage($event, 'screenSaverVideo')"
                class="clear-pb"><i class="bi bi-trash"></i></a>
              <a *ngIf="settingsForm.controls.screenSaverVideo.value" class="cursor-pointer"
                (click)="showVideo($event,  currentSettings?.screenSaverVideoData)">
                <i class="bi bi-camera-video"></i></a>
        </label>
        <div class="col-7">
          <div class="input-group custom-file-button flex-row-reverse">
            <label class="label-input-file" [for]="'screenSaverVideo-' + entity.id">
              <div>
                <div class="label-input-file-placeholder">
                  {{currentSettings?.screenSaver?.fileName
                  ? currentSettings?.screenSaver?.fileName
                  : ('COMMON.UPLOADIMAGE' | translate)
                  }}
                </div>
                <div class="label-input-file-browse">Browse</div>
              </div>
            </label>
            <input type="file" class="form-control rounded-0"  [id]="'screenSaverVideo-' + entity.id"
              (change)="uploadFile($event,'screenSaverVideo')"
              [id]="'screenSaverVideo-' + entity.id" formControlName="screenSaverVideo">
            <hbo-field-validation fieldName="screenSaverVideo"></hbo-field-validation>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row p-4" *ngIf="entityApps.includes(5)">
    <div class="col-6" *ngIf="user.roleId === 1">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">Technologies</h4>
      <div class="mb-3"  formGroupName="technologies">
        <div class="mb-3">
          <label class="form-check-label fw-bold" [for]="'boxIA-' + entity.id">Box AI</label>
          <input class="form-check-input float-end" type="checkbox" [id]="'boxIA-' + entity.id" formControlName="boxIA">
        </div>
        <div class="mb-3">
          <label class="form-check-label fw-bold" [for]="'nearPd-' + entity.id">Near PD</label>
          <input class="form-check-input float-end" type="checkbox" [id]="'nearPd-' + entity.id" formControlName="nearpd">
        </div>
        <div class="mb-3">
          <label class="form-check-label fw-bold" [for]="'corridor-' + entity.id">Corridor</label>
          <input class="form-check-input float-end" type="checkbox" [id]="'corridor-' + entity.id" formControlName="corridor">
        </div>
      </div>
    </div>
    <div class="col-6" *ngIf="entity.entityTypeId === 4 && user.roleId !== 4">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">External Reporting</h4>
      <div class="row">
        <label [for]="'externalReportingUser-' + entity.id" class="col-5 col-form-label">User</label>
        <div class="col-7">
          <input type="text" class="form-control border-0 rounded-0" [id]="'externalReportingUser-' + entity.id"
            formControlName="externalReportingUser">
        </div>
      </div>
    </div>
    <div class="col-6" *ngIf="entity.entityTypeId !== 4 && entity.entityTypeId !== 3 && user.roleId === 1">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">External Communications</h4>
      <div class="row mb-3">
        <!-- <div class="mb-3">
          <label class="form-check-label fw-bold" [for]="'externalReportingEnabled-' + entity.id">Enable External Reporting</label>
          <input class="form-check-input float-end" type="checkbox" [id]="'externalReportingEnabled-' + entity.id" formControlName="externalReportingEnabled">
        </div> -->
        <label [for]="'externalReporting-' + entity.id" class="col-5 col-form-label">External Reporting</label>
        <div class="col-7">
          <select class="form-select" [id]="'externalReporting-' + entity.id" formControlName="externalReporting">
            <option value="None">None</option>
            <option value="SurfacingClient">SurfacingClient</option>
            <option value="IndoClient">IndoClient</option>
            <option value="SzajnaClient">SzajnaClient</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div class="row p-4" *ngIf="entityApps.includes(6) && currentSettings?.appFrontendDesign?.m4u">
    <div class="col-6" *ngIf="entity.entityTypeId !== 4">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">Catalog</h4>
      <div class="row" formGroupName="catalogs">
        <div class="col-6">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" [id]="'mimic-' + entity.id" formControlName="mimic">
            <label class="form-check-label" [for]="'mimic-' + entity.id">
              MIMIC-2017-2018
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" [id]="'liqRX-' + entity.id" formControlName="liqRX">
            <label class="form-check-label" [for]="'liqRX-' + entity.id">
              LIQ-RX-2019
            </label>
          </div>
        </div>
        <div class="col-6">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" [id]="'liq-' + entity.id" formControlName="liq">
            <label class="form-check-label" [for]="'liq-' + entity.id">
              LIQ_2019
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" [id]="'basic-' + entity.id" formControlName="basic">
            <label class="form-check-label" [for]="'basic-' + entity.id">
              BASICSHAPES
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6" *ngIf="entity.entityTypeId === 4">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">Shipping Address</h4>
      <div class="row mb-3" formGroupName="shippingAddress">
        <label [for]="'address-' + entity.id" class="col-5 col-form-label">Address</label>
        <div class="col-7">
          <input type="text" class="form-control border-0 rounded-0" [id]="'address-' + entity.id"
            formControlName="address">
        </div>
        <label [for]="'country-' + entity.id" class="col-5 col-form-label">Country</label>
        <div class="col-7">
          <input type="text" class="form-control border-0 rounded-0" [id]="'country-' + entity.id"
            formControlName="country">
        </div>
        <label [for]="'cityAndZipCode-' + entity.id" class="col-5 col-form-label">City and Code Zip</label>
        <div class="col-7">
          <input type="text" class="form-control border-0 rounded-0" [id]="'cityAndZipCode-' + entity.id"
            formControlName="cityAndZipCode">
        </div>
      </div>
    </div>

    <div class="col-6">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">Management Orders</h4>

      <div formGroupName="managementOrders">
        <ng-container *ngIf="entity.entityTypeId !== 4">
          <div class="row mb-3">
            <label [for]="'validatorEmail-' + entity.id" class="col-5 col-form-label">E-mail of the validator</label>
            <div class="col-7">
              <input type="email" class="form-control border-0 rounded-0" [id]="'validatorEmail-' + entity.id"
                formControlName="validatorEmail">
            </div>
          </div>
          <div class="row" formGroupName="specialRates">
            <div class="col-5">
              <label class="fw-bold">Special rates</label>
            </div>
            <div class="col-7">
              <div class="form-check d-inline-block me-2">
                <input class="form-check-input" type="checkbox" [id]="'uniformity-' + entity.id"
                  formControlName="uniformity">
                <label class="form-check-label" [for]="'uniformity-' + entity.id">Uniformity</label>
              </div>
              <div class="form-check d-inline-block">
                <input class="form-check-input" type="checkbox" [id]="'vip-' + entity.id" formControlName="vip">
                <label class="form-check-label" [for]="'vip-' + entity.id">VIP</label>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="entity.entityTypeId === 4">
          <div class="row mb-3">
            <label [for]="'reminderEmail-' + entity.id" class="col-5 col-form-label">E-mail to send reminders</label>
            <div class="col-7">
              <input type="email" class="form-control border-0 rounded-0" [id]="'reminderEmail-' + entity.id"
                formControlName="reminderEmail">
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="p-4" *ngIf="user.profileId !== 2 && !(entity.id === user.entityId && user.profileId !== 3 && !(user.roleId === 4 && user.profileId === 1))">
    <button type="button" class="btn btn-outline-secondary me-2">Cancel</button>
    <button type="submit" class="btn btn-dark">{{ 'COMMON.SAVE_CHANGES' | translate }}</button>
  </div>
</form>

<hbo-preview-external-settings #externalSettings></hbo-preview-external-settings>